import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addSettingsFailure,
  //
  addSettingsSuccess,
  deleteSettingsFailure,
  //
  deleteSettingsSuccess,
  editSettingsFailure,
  //
  editSettingsSuccess,
  fetchSettings as fetchSettingsAction,
  fetchSettingsFailure,
  fetchSettingsSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
} from "./actions";
import {
  ADD_SETTINGS,
  DELETE_SETTINGS,
  EDIT_SETTINGS,
  FETCH_SETTINGS,
  GET_VIEW_DATA,
} from "./constants";

export function* fetchSettingsSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.data ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/review-setting?${query}`,
      payload
    );
    yield put(fetchSettingsSuccess(data));
  } catch (e) {
    yield put(fetchSettingsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching news!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/review-setting/${payload}`
    );
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addSettingsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/review-setting/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Settings added successfully!"));
      yield put(addSettingsSuccess());
      if (payload?.history) {
        payload.history.push("/d/review-settings");
      }
    }
  } catch (e) {
    yield put(addSettingsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editSettingsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/review-setting/edit/${payload.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Settings updated successfully!"));
      yield put(editSettingsSuccess());
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(editSettingsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteSettingsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const user = yield select((state) => state?.AuthReducer?.user);

  try {
    const data = yield call(
      api(token).delete,
      `/api/review-setting/${payload}`
    );
    if (data) {
      yield put(successAlert("Settings deleted successfully!"));
      yield put(deleteSettingsSuccess());
      yield put(
        fetchSettingsAction({
          data: { page: 1, limit: 10, admin_id: user?.id },
        })
      );
    }
  } catch (e) {
    yield put(deleteSettingsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchSettingsFlow() {
  yield takeEvery(FETCH_SETTINGS, fetchSettingsSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addSettingsFlow() {
  yield takeEvery(ADD_SETTINGS, addSettingsSaga);
}
export function* editSettingsFlow() {
  yield takeEvery(EDIT_SETTINGS, editSettingsSaga);
}
export function* deleteSettingsFlow() {
  yield takeEvery(DELETE_SETTINGS, deleteSettingsSaga);
}
export default function* ReviewSettingsSaga() {
  yield all([
    fetchSettingsFlow(),
    addSettingsFlow(),
    editSettingsFlow(),
    deleteSettingsFlow(),
    getViewDataFlow(),
  ]);
}
